import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Origen } from "./components/Origen";
import { FeaturedDishes } from "./components/FeaturedDishes"; // eslint-disable-line no-unused-vars
import { Gallery } from "./components/Gallery";
import { MenuSection } from "./components/MenuSection";
import { Contact } from "./components/Contact";
import { FloatingActions } from "./components/FloatingActions";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App bg-black text-white min-h-screen antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Origen />
        <Gallery />
        <MenuSection />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default App;
